export default __webpack_public_path__ + "static/media/order-white.fdcde907.png";